import { Checkbox, Divider, CircularProgress } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  selectAllDevices,
  selectDevice,
} from "../../../../state/ducks/devices/operations";
import { DeviceApp } from "../../../../state/ducks/devices/types";
import { localized } from "../../../../state/i18n/i18n";
import { AppState } from "../../../../state/store";
import { GetColorByIndex } from "../../../../utilities/colors";
import DeviceContentContainer from "../device-content-container/device-content-container";
import DeviceMenuItem from "./device-menu-item";
import "./device-menu.scss";

const mapStateToProps = (state: AppState) => {
  return {
    devices: state.devicesReducer.devices,
    selectedAll: state.devicesReducer.selectedAll,
    pending: state.devicesReducer.pending,
    retrivalStatus: state.devicesReducer.devicesRetrivalFailed,
  };
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectDevice: async (idenitifier: string) =>
    (await selectDevice(idenitifier))(dispatch),
  selectAllDevices: () => selectAllDevices()(dispatch),
});

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

interface State {
  showDeviceGraph: boolean;
}

class DeviceMenuApp extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { showDeviceGraph: false };
  }

  public render() {
    return (
      <div>
        {!this.state.showDeviceGraph && this.showDeviceMenuTopContainer()}
        {!this.state.showDeviceGraph && this.showDeviceMenuItems()}
        {this.state.showDeviceGraph && (
          <div className="flexDirectionRow flexWrap spaceBetween scroll paddingBottom">
            <DeviceContentContainer />
          </div>
        )}
        {this.showNavigationButton()}
      </div>
    );
  }

  private showNavigationButton = () => (
    <div
      onClick={this.showGraph}
      className="pageBottomNavigator flexDirectionRow"
    >
      {this.state.showDeviceGraph && (
        <ArrowBackIosIcon className="arrowBackLeft"></ArrowBackIosIcon>
      )}

      {this.state.showDeviceGraph
        ? localized("BackToDevices")
        : localized("ContinueToGraphs")}

      {!this.state.showDeviceGraph && (
        <ArrowForwardIosIcon className="arrowForwardRight"></ArrowForwardIosIcon>
      )}
    </div>
  );

  private showGraph = () => {
    this.setState({
      showDeviceGraph: this.state.showDeviceGraph ? false : true,
    });
  };

  private showDeviceMenuTopContainer = () => (
    <div className={"topContainer devicesTableTopContainer padding"}>
      <div className="width100">
        <div className="boldText">{localized("Devices")}</div>
        <div className="availableDevices">{localized("AvailableDevices")}</div>
      </div>
    </div>
  );

  private mapDevices = (d: DeviceApp, index: number) => (
    <DeviceMenuItem
      onMenuItemClicked={this.props.selectDevice}
      checkBoxColor={GetColorByIndex(index)}
      selected={d.selected}
      name={d.deviceId?  d.deviceId : "" }
      active={d.active}
      key={d.deviceId}
      identifier={d.deviceId}
    />
  );

private getUserDevices = () => {

  if (this.props.devices.length > 0) {
  return !this.props.pending && (
    <div className="flexDirectionRow flexWrap spaceEvenly scroll paddingBottom">
      {this.props.devices.map(this.mapDevices)}
    </div>
  )
  }
  else if (this.props.retrivalStatus === false) {
    return (
      <div className="emptyMessageSettings">{localized("LoadingDevices")}</div>
    );
  } else
    return (
      <div className="emptyMessageSettings">{localized("NoDevices")}</div>
    );

}

  private showDeviceMenuItems = () => (
    <div>
      <Divider />
      <div className="chooseAllOrDismissContainer">
        <div className="chooseAllOrDismiss">
          {localized("ChooseOrDismissAll")}
        </div>
        <Checkbox
          onClick={this.props.selectAllDevices}
          color={"primary"}
          className="checkBoxStyle"
          checked={this.props.selectedAll}
        />
      </div>

      <Divider />
      {this.props.pending && <CircularProgress className="spinner" />}

      {this.getUserDevices()}
     
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceMenuApp);
